// اللَّهُ لَا إِلَٰهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ ۚ لَا تَأْخُذُهُ سِنَةٌ وَلَا نَوْمٌ ۚ
// لَهُ مَا فِي السَّمَاوَاتِ وَمَا فِي الْأَرْضِ ۗ مَنْ ذَا الَّذِي يَشْفَعُ عِنْدَهُ إِلَّا بِإِذْنِهِ ۚ
// يَعْلَمُ مَا بَيْنَ أَيْدِيهِمْ وَمَا خَلْفَهُمْ ۖ وَلَا يُحِيطُونَ بِشَيْءٍ مِنْ عِلْمِهِ إِلَّا بِمَا شَاءَ ۚ
// وَسِعَ كُرْسِيُّهُ السَّمَاوَاتِ وَالْأَرْضَ ۖ وَلَا يَئُودُهُ حِفْظُهُمَا ۚ وَهُوَ الْعَلِيُّ الْعَظِيمُ
// (Bakara 255)

/**
 * SEKMELER ARASI OTURUM DEVRİ.
 *
 * SORUN (kullanıcı 2026-09-03): "menüler istendiğinde ayrı sekmede o menünün içeriği açılabilmeli
 * — formsa form, datagrid'se datagrid". Menü öğeleri gerçek `<a href>` olduğu için Ctrl+tık zaten
 * yeni sekme açıyordu, ama açılan sekme LOGIN'e düşüyordu: "beni hatırla" seçilmediğinde oturum
 * `sessionStorage`'da tutulur ve sessionStorage sekmeler arasında PAYLAŞILMAZ (ölçüldü).
 *
 * ÇÖZÜM ve neden bu: oturumu kalıcı olarak `localStorage`'a taşımak sorunu çözerdi ama "tarayıcı
 * kapanınca çıkış" güvencesini yok ederdi — ortak bilgisayarda oturum açık kalırdı. Bunun yerine
 * kısa ömürlü bir EL SIKIŞMA yapılır:
 *
 *   1. Yeni sekme açılır, sessionStorage boştur → localStorage'a "oturum istiyorum" işareti yazar.
 *   2. Açık sekmeler `storage` olayını görür ve oturumu localStorage'a GEÇİCİ olarak koyar.
 *   3. Yeni sekme okur, kendi sessionStorage'ına alır ve geçici kaydı hemen SİLER.
 *
 * Böylece oturum diskte kalıcı durmaz; son sekme de kapanınca hiçbir yerde kalmaz.
 * Devir yalnız AYNI kaynakta (origin) çalışır — tarayıcı güvenlik sınırı budur.
 */

const OTURUM_ANAHTARI = 'elpo-core-auth';
const ISTEK_ANAHTARI = 'elpo-core-auth-devir-istek';
const CEVAP_ANAHTARI = 'elpo-core-auth-devir-cevap';

/** Cevap bu süre içinde gelmezse devir başarısız sayılır; kullanıcı giriş ekranını görür. */
const BEKLEME_MS = 350;

function guvenliOku(depo: Storage, anahtar: string): string | null {
  try { return depo.getItem(anahtar); } catch { return null; }
}

function guvenliYaz(depo: Storage, anahtar: string, deger: string): void {
  try { depo.setItem(anahtar, deger); } catch { /* gizli mod / kota */ }
}

function guvenliSil(depo: Storage, anahtar: string): void {
  try { depo.removeItem(anahtar); } catch { /* gizli mod */ }
}

/**
 * Açık sekmelerin dinleyicisi. Bir kez kurulur; başka sekme oturum isterse cevap verir.
 * Yalnız GERÇEKTEN oturumu olan sekme cevaplar — oturumsuz sekme sessiz kalır.
 */
export function oturumDevriniDinle(): void {
  window.addEventListener('storage', (olay) => {
    if (olay.key !== ISTEK_ANAHTARI || olay.newValue === null) return;

    const oturum = guvenliOku(sessionStorage, OTURUM_ANAHTARI) ?? guvenliOku(localStorage, OTURUM_ANAHTARI);
    if (!oturum) return;

    guvenliYaz(localStorage, CEVAP_ANAHTARI, oturum);
    // Geçici kayıt cevap alındıktan sonra silinir; alınmasa bile burada temizlenir ki
    // oturum diskte unutulmasın.
    window.setTimeout(() => guvenliSil(localStorage, CEVAP_ANAHTARI), BEKLEME_MS * 3);
  });
}

/**
 * Yeni sekmenin açılışta çağırdığı devir. Oturum zaten varsa hiçbir şey yapmaz.
 * @returns oturum devralındıysa true.
 */
export async function oturumuDevralmayiDene(): Promise<boolean> {
  if (guvenliOku(sessionStorage, OTURUM_ANAHTARI)) return false;
  if (guvenliOku(localStorage, OTURUM_ANAHTARI)) return false; // "beni hatırla" zaten açık

  guvenliSil(localStorage, CEVAP_ANAHTARI);
  guvenliYaz(localStorage, ISTEK_ANAHTARI, String(Date.now()));

  const oturum = await new Promise<string | null>((coz) => {
    const bitir = (deger: string | null) => {
      window.removeEventListener('storage', dinleyici);
      window.clearTimeout(zamanAsimi);
      coz(deger);
    };
    const dinleyici = (olay: StorageEvent) => {
      if (olay.key === CEVAP_ANAHTARI && olay.newValue) bitir(olay.newValue);
    };
    window.addEventListener('storage', dinleyici);
    const zamanAsimi = window.setTimeout(() => bitir(guvenliOku(localStorage, CEVAP_ANAHTARI)), BEKLEME_MS);
  });

  guvenliSil(localStorage, ISTEK_ANAHTARI);
  guvenliSil(localStorage, CEVAP_ANAHTARI);

  if (!oturum) return false;
  guvenliYaz(sessionStorage, OTURUM_ANAHTARI, oturum);
  return true;
}
